import './App.css';
import Weather from './Weather';

function App() {
  return (
    <div className="App">
      <div className="container">
      <Weather defaultCity="Kyiv" />
<footer>
  Was coded by Kristina Zavalkova and is {""}
<a href="https://github.com/kristel-amk/react-weather-app">open-sourced on GitHub</a>
 </footer>
 </div>
 </div>
  );
}

export default App;
